import { Grid, Menu, Segment } from '@mairistem/composants';
import type { Exercice } from '@mairistem/comptabilite';
import { fetchModuleActif, Module, Produit } from '@mairistem/finances-utils';
import React from 'react';
import StorageKey from '../../constants/common/storage';
import { getExercice } from '../../utils/feuilleSaisie/exercice';
import FeuilleSaisieList from './FeuilleSaisie/FeuilleSaisieList';
import NotePresentationListe from './NotePresentation/NotePresentationListe';
import RegleCalculList from './RegleCalcul/List/RegleCalculList';
import './Parametres.css';

const TAB = {
	FEUILLE_SAISIE: 'Feuille de saisie',
	REGLE_CALCUL: 'Règles de calcul personnalisées',
	NOTE_PRESENTATION: 'Note de présentation',
};

const Parametres = () => {
	const [currentTab, setCurrentTab] = React.useState(TAB.FEUILLE_SAISIE);
	const [exercice, setExercice] = React.useState<Exercice>(null);
	const [hasModuleNotePresentation, setHasModuleNotePresentation] =
		React.useState(false);
	const [, setNoteModele] = React.useState(null);

	const fetchExercice = async () => {
		const identifiantExercice = Number(
			sessionStorage.getItem(StorageKey.IDENTIFIANT_EXERCICE),
		);
		if (identifiantExercice) {
			setExercice(await getExercice(identifiantExercice));
		}
	};

	// biome-ignore lint/correctness/useExhaustiveDependencies: Pas besoin de 'fetchExercice'
	React.useEffect(() => {
		fetchExercice();

		const getModuleActif = async () => {
			setHasModuleNotePresentation(
				await fetchModuleActif(
					StorageKey.MODULE_NOTE_PRESENTATION,
					Produit.ELABORATION_BUDGET,
					Module.NOTE_PRESENTATION,
				),
			);
		};

		getModuleActif();
	}, []);

	const handleOpenMenu = (_e, { name }) => {
		setCurrentTab(name);
	};

	const handleChangeNoteModele = (modele) => {
		setNoteModele(modele);
	};

	return (
		<Grid id="parametres">
			<Grid.Row>
				<Grid.Column
					widescreen={2}
					largeScreen={2}
					computer={2}
					tablet={5}
					mobile={16}
					textAlign="center"
					className="wrapper"
					stackable
				>
					<Menu pointing vertical fluid>
						<Menu.Item
							active={currentTab === TAB.FEUILLE_SAISIE}
							data-testid="menuFeuilleSaisie"
							name={TAB.FEUILLE_SAISIE}
							onClick={handleOpenMenu}
						>
							{TAB.FEUILLE_SAISIE}
						</Menu.Item>
						{hasModuleNotePresentation && (
							<Menu.Item
								active={currentTab === TAB.NOTE_PRESENTATION}
								data-testid="menuNotePresentation"
								name={TAB.NOTE_PRESENTATION}
								onClick={handleOpenMenu}
							>
								{TAB.NOTE_PRESENTATION}
							</Menu.Item>
						)}
						<Menu.Item
							active={currentTab === TAB.REGLE_CALCUL}
							data-testid="menuRegleCalcul"
							name={TAB.REGLE_CALCUL}
							onClick={handleOpenMenu}
						>
							{TAB.REGLE_CALCUL}
						</Menu.Item>
					</Menu>
				</Grid.Column>
				<Grid.Column
					widescreen={14}
					largeScreen={14}
					computer={14}
					tablet={11}
					mobile={16}
					stretched
					id="menu-content"
				>
					<Segment attached="bottom">
						{currentTab === TAB.FEUILLE_SAISIE && (
							<FeuilleSaisieList exercice={exercice} />
						)}
						{currentTab === TAB.REGLE_CALCUL && <RegleCalculList />}
						{currentTab === TAB.NOTE_PRESENTATION && (
							<NotePresentationListe onModelChange={handleChangeNoteModele} />
						)}
					</Segment>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default Parametres;
